import React from 'react';
import { useStorageReducer } from 'react-storage-hooks';

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_SOUND_SEEK':
      return { ...state, soundSeek: action.soundSeek };
    case 'SET_USER_STATE':
      return { ...state, userState: action.userState };
    default:
      return state;
  }
};

const defaultState = {
  soundSeek: 0,
  userState: '',
};

const usePlayerReducer = (storageKey = 'Musica:Player', intialValue = defaultState) => {
  return useStorageReducer(localStorage, storageKey,
    reducer, intialValue
  );
};

export default usePlayerReducer;